import { __ } from '@wordpress/i18n';
import MicroModal from 'micromodal';
import { qs, qsAll } from '../dom-helpers';
import AJAX from './class.AJAX';
import Abstract from './class.Abstract';
import FormValidator from './class.FormValidator';

class LoginModal {
  constructor() {
    if (!qs('.main-header__login-button')) return;

    this.loginButtons = qsAll('.main-header__login-button');
    this.cartButtons = qsAll('.main-header__cart-link--guest');
    this.form = qs('.login-form');
    this.formStatus = qs('.alert', this.form);
    this.submitButton = qs('.submit-btn', this.form);

    this._run();
  }

  _run() {
    this._initModal();
    this._initEventListeners();
    this._handleSubmit();
  }

  _initEventListeners() {
    this.loginButtons.forEach((button) => button.addEventListener('click', () => this._openModal()));

    if (this.cartButtons.length) {
      this.cartButtons.forEach((button) => button.addEventListener('click', () => this._openModal()));
    }
  }

  _initModal() {
    MicroModal.init();
  }

  _openModal() {
    MicroModal.show('login-modal');
  }

  _handleSubmit() {
    const _this = this;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!this._isFormValid()) return;

      const data = new FormData(this.form);

      AJAX.post({
        action: 'mst_somi_login',
        data: Abstract.formDataToObject(data),
        beforeSend() {
          _this.submitButton.disabled = true;
        },
        complete() {
          _this.submitButton.disabled = false;
        },
        success(response) {
          const level = response.success ? 'success' : 'error';
          _this._writeStatus(level, response.data.message);

          if (response.data.redirect_url) {
            location = response.data.redirect_url;
          }
        },
      });
    });
  }

  _isFormValid() {
    return new FormValidator().isValid(this.form, {
      billing_ssn: {
        presence: {
          message: __('^SSN field can\'t be empty', 'mst_somi_js'),
        },
        _ssn: {
          message: __('^Incorrect SSN format', 'mst_somi_js'),
        }
      },
      password: {
        presence: {
          message: __('^Password field can\'t be empty', 'mst_somi_js'),
        },
      },
    });
  }

  _writeStatus(level, status) {
    Abstract.fadeIn(this.formStatus);

    this.formStatus.classList.add(level);
    this.formStatus.innerText = status;

    setTimeout(() => {
      Abstract.fadeOut(this.formStatus);

      this.formStatus.classList.remove(level);
      this.formStatus.innerText = '';
    }, 8000);
  }
}

export default LoginModal;
